import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"

export interface ReportPayload {
    reportedUserNo: number;
    roomId?: string;
    messageId?: number;
    reasonCode?: string;
    reason?: string;
}

/**
 * 채팅 사용자 신고 Repository — wiz-chat 의 /api/chat/reports 와 1:1 매핑.
 */
export class ReportRepository {
    static onPostReport = (payload: ReportPayload) => {
        return onRequest({
            url: getApiUrl('chatReports'),
            method: RequestMethod.POST,
            params: payload,
        })
    }
}
